import React from 'react';
import { CreateSegmentButton } from './CreateSegmentButton';
import styles from './EngageSegmentsTab.module.css';
import { SegmentsManager } from './segments-manager';

export const EngageSegmentsTab: React.FC = () => {
  return (
    <article className={styles.segmentsPage}>
      <header>
        <hgroup>
          <h1>Segments</h1>
          <p>Manage your customer segments</p>
        </hgroup>
        <CreateSegmentButton />
      </header>

      <SegmentsManager />
    </article>
  );
};
